var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9928 9.55802C12.9928 10.9248 11.8938 12.0328 10.5381 12.0328C9.1824 12.0328 8.08337 10.9248 8.08337 9.55802C8.08337 8.19127 9.1824 7.08331 10.5381 7.08331C11.8939 7.08331 12.9928 8.19127 12.9928 9.55802ZM12.6337 13.789H8.48245V27.2005H12.6337V13.789ZM19.2695 13.789H15.288V27.2005H19.2695C19.2695 27.2005 19.2695 22.226 19.2695 20.1604C19.2695 18.2745 20.1376 17.1519 21.7991 17.1519C23.3259 17.1519 24.0593 18.2296 24.0593 20.1604C24.0593 22.0913 24.0593 27.2005 24.0593 27.2005H28.1904C28.1904 27.2005 28.1904 22.3009 28.1904 18.7086C28.1904 15.1162 26.1548 13.3799 23.3108 13.3799C20.4668 13.3799 19.2694 15.5952 19.2694 15.5952V13.789H19.2695Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c4558dd737884afff08c59284015b270.svg";
export { ForwardRef as ReactComponent };